import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { Form } from 'react-redux-form';
import CustomSearchableDropdownWrapper from "../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    SelectFieldFloatingLabel as Select,
    InputFieldFloatingLabel as InputField,
} from "../../../../common/custom-form/select-filter.component";
import { withRouter } from 'react-router-dom';
import { inventoryEquipmentActions } from "../../../../../store/external/inventory/equipment.reducer";
import { ConfirmationNotificationModal } from "../../../../common/modal/confirmation-modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { Loading } from "../../../../common/loading";
import {
    DATA_TYPE,
    PLACEHOLDER,
    MODAL_TITLE,
    EQUIPMENT_MSG,
    MAX_LENGTH,
} from "../../../../../constants/external-constants";
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';

class FormView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showNotif: false,
            isSaving: false,
            notifTitle: null,
            showValidationModal: false,
            showModal: false,
            updateEquipment: false,
            modalMessage: "",
            loading: true,
            exitForm: false,
            isError: false,
            isRequiredNotEmpty: false,
            acceptConf: false,
            defaultCompanyCode: [],
        };

        this.handleDisableSaveButton = this.handleDisableSaveButton.bind();
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        this.props.equipmentIsNotLoaded();
        if (
            !this.props.hasLoadedEquipmentData
        ) {
            if (!this.props.createNew) {
                await this.props.getAllVendors(1, this.props.selectedEquipment?.Vendor);
                await this.props.getAllCircuitTypes(1, this.props.selectedEquipment?.CircuitType);
                await this.props.getAllContracts(parseInt(this.props.selectedEquipment?.VendorId) ?? 0, 1, this.props.selectedEquipment?.ContractCode);
                await this.props.getAllGlCodes(1, this.props.selectedEquipment?.GlCode);
                await this.props.getAllCostCenters(1, this.props.selectedEquipment?.CostCenter);
                await this.props.getAllCompanyCodes(parseInt(this.props.selectedEquipment?.CostcodeID) ?? 0, 1, this.props.selectedEquipment?.CompanyCode);
                const equipmentId = this.props.selectedEquipment?.EquipmentId;
                if (equipmentId) {
                    await this.props.getInventoryEquipmentDetailsById(equipmentId);
                }
            }
            else {
                await this.props.getAllVendors(1, '');
                await this.props.getAllCircuitTypes(1, '');
                await this.props.getAllContracts(0, 1, '');
                await this.props.getAllGlCodes(1, '');
                await this.props.getAllCostCenters(1, '');
                await this.props.getAllCompanyCodes(0, 1, '');
            }
            this.props.markEquipmentLoaded();
        }
        this.props.equipmentIsLoaded();
    }
    
    handleConfirmationModal = async (buttonType) => {
        this.setState({ acceptConf: true });
        const { submitRequest, checkDuplicate, inventoryEquipmentForm } = this.props;
        const isUpdate = inventoryEquipmentForm.equipmentId > 0 ? true : false;
        var processMessage = isUpdate
            ? EQUIPMENT_MSG.UPDATED_MSG
            : EQUIPMENT_MSG.CREATED_MSG;

        if(buttonType === "ok" && !this.handleDisableSaveButton()) {
            var duplicateData = await checkDuplicate();
            if (duplicateData && duplicateData.EquipmentId > 0 && duplicateData.EquipmentId !== inventoryEquipmentForm.equipmentId) {
                this.setState( prev => ({
                    notifTitle: MODAL_TITLE.ERROR,
                    showModal: false,
                    isError: true,
                    showValidationModal: true,
                    modalMessage: EQUIPMENT_MSG.EXISTS_MSG,
                    exitForm: false,
                    isSaving: false
                }));
            } else {
                var result = await submitRequest();
                if (result.Success) {
                    this.setState( prev => ({
                        notifTitle: MODAL_TITLE.SUCCESS,
                        showModal: false,
                        showValidationModal: true,
                        modalMessage: processMessage,
                        exitForm: isUpdate ? false : true
                    }));
                } else {
                    this.setState({
                        showModal: false,
                        showValidationModal: true,
                        modalMessage: result.Message,
                        exitForm: false
                    });
                }
            }
        } else {
            this.setState({
                showModal: false,
                showValidationModal: false,
                exitForm: false
            });
        }
    }

    handleValidateModal = async () =>{
        const { getInventoryEquipmentDetailsById, inventoryEquipmentForm } = this.props
        if(this.state.exitForm) {
            this.setState({
                showValidationModal: false,
                updateEquipment: true
            })
            this.props.closeForm();
        }else{
            this.setState({
                showValidationModal: false,
                updateEquipment: false
            })
            await getInventoryEquipmentDetailsById(inventoryEquipmentForm.equipmentId);
        }

    }

    onClick = () =>{
        if (!isNaN(parseInt(this.props.inventoryEquipmentForm.equipmentId))
            && parseInt(this.props.inventoryEquipmentForm.equipmentId) > 0) {
            this.setState({
                showModal: true,
                notifTitle: MODAL_TITLE.UPDATE,
                acceptConf: false,
                modalMessage: EQUIPMENT_MSG.CONFIRM_UPDATE_MSG
            })

        } else {
            this.setState({isSaving: true});
            this.handleConfirmationModal("ok");
        }

    }

    getValue = (val) => {
        var value = parseInt(val);
        if (val === null || val === undefined) return 0;
        else if (isNaN(value)) return 0;
        else return value;
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];
        
        return translation[locale][key];
    }

    handleDisableSaveButton = () => {
        const { inventoryEquipment, inventoryEquipmentForm, createNew } = this.props;

        const normalizeValue = (val) => val === 0 || val === null || val === '' ? 0 : val;

        if (!createNew) {
            const { inventoryEquipmentDetails } = inventoryEquipment;
            const floats = ['discountedOrderCost','orderCost', 'mrc', 'nrc'];
            const fieldsToCompare = [
                'model', 'productName', 'equipmentTypeId', 'equipmentStatusId',
                'vendorId', 'circuitTypeId', 'contractId', 'discountedOrderCost',
                'mrc', 'nrc', 'glCodeId', 'costCodeId', 'companyCodeId', 'vipId', 'orderCost'
            ];
            const requiredFields = ['equipmentTypeId','model','equipmentStatusId',
                'vendorId','circuitTypeId'];

            let hasChanges = false;
            for (let field of fieldsToCompare) {
                const oldValue = normalizeValue(inventoryEquipmentDetails[field]);
                const newValue = normalizeValue(inventoryEquipmentForm[field]);

                if (floats.includes(field)) {
                    if (parseFloat(newValue) !== parseFloat(oldValue)) {
                        hasChanges = true;
                        break;
                    }
                } else {
                    if (newValue !== oldValue) {
                        hasChanges = true;
                        break;
                    }
                }
            }

            for (let field of requiredFields) {
                const value = normalizeValue(inventoryEquipmentForm[field]);
                if (value === 0) return true;
            }
            return !hasChanges;

        }
        else {
            let model = inventoryEquipmentForm.model === undefined
                || inventoryEquipmentForm.model === null
                || ((typeof inventoryEquipmentForm.model) === 'string' && inventoryEquipmentForm.model.trim() === '');

          return this.getValue(inventoryEquipmentForm.equipmentTypeId) === 0
                || model
                || this.getValue(inventoryEquipmentForm.equipmentStatusId) === 0
                || this.getValue(inventoryEquipmentForm.vendorId) === 0
                || this.getValue(inventoryEquipmentForm.circuitTypeId) === 0
                || isNaN(parseInt(inventoryEquipmentForm.orderCost));
        }
    };


    handleVendorChange = async (selectedVendorId) => {
        await this.props.selectedVendor(selectedVendorId);
        await this.props.getAllContracts(selectedVendorId, 1, "");
    };
    loadMoreVendor = (searchString) => {
        const { inventoryEquipment } = this.props;
        const nextPage = (inventoryEquipment.vendorPage || 1) + 1;
        this.props.getAllVendors(nextPage, searchString);
    };

    handleVendorSearch = (query) => {
        this.props.getAllVendors(1, query);
    };


    loadMoreCircuitType = (searchString) => {
        const { inventoryEquipment } = this.props;
        const nextPage = (inventoryEquipment.circuitTypePage || 1) + 1;
        this.props.getAllCircuitTypes(nextPage, searchString);
    };

    handleCircuitTypeSearch = (query) => {
        this.props.getAllCircuitTypes(1, query);
    };


    loadMoreGlCode = (searchString) => {
        const { inventoryEquipment } = this.props;
        const nextPage = (inventoryEquipment.glCodePage || 1) + 1;
        this.props.getAllGlCodes(nextPage, searchString);
    };

    handleGlCodeSearch = (query) => {
        this.props.getAllGlCodes(1, query);
    };


    handleCostCenterChange = async (selectedKey) => {
        this.props.selectedCostCenter(selectedKey);
        await this.props.getAllCompanyCodes(selectedKey, 1, "");
    };

    loadMoreCostCenter = (searchString) => {
        const { inventoryEquipment } = this.props;
        const nextPage = (inventoryEquipment.costCenterPage || 1) + 1;
        this.props.getAllCostCenters(nextPage, searchString);
    };

    handleCostCenterSearch = (query) => {
        this.props.getAllCostCenters(1, query);
    };


    loadMoreCompanyCode = (searchString) => {
        const { inventoryEquipment, inventoryEquipmentForm } = this.props;
        const costCodeId = inventoryEquipmentForm.costCodeId || 0;
        const nextPage = (inventoryEquipment.companyCodePage || 1) + 1;
        this.props.getAllCompanyCodes(costCodeId, nextPage, searchString);
    };

    handleCompanyCodeSearch = (query) => {
        const { inventoryEquipmentForm } = this.props;
        const costCodeId = inventoryEquipmentForm.costCodeId || 0;
        this.props.getAllCompanyCodes(costCodeId, 1, query);
    };


    loadMoreContract = (searchString) => {
        const { inventoryEquipment, inventoryEquipmentForm } = this.props;
        const nextPage = (inventoryEquipment.contractPage || 1) + 1;
        this.props.getAllContracts(inventoryEquipmentForm.vendorId, nextPage, searchString);
    };

    handleContractSearch = (query) => {
        const { inventoryEquipmentForm } = this.props;
        this.props.getAllContracts(inventoryEquipmentForm.vendorId, 1, query);
    };

    convertToDecimal = (value) => {
        if (typeof value === "string") return value;
        const result = (Math.round(value * 100) / 100).toFixed(2);

        return result;
    }
    render() {
        const { inventoryEquipment, inventoryEquipmentForm, isReadAndWrite } = this.props;

        const { isVendorLoading, hasMoreVendor, isCircuitTypeLoading, hasMoreCircuitType, isContractLoading, hasMoreContract, 
            isGlCodeLoading, hasMoreGlCode, isCostCenterLoading, hasMoreCostCenter, isCompanyCodeLoading, hasMoreCompanyCode } = inventoryEquipment;

        if (!inventoryEquipmentForm.isLoaded && !this.props.createNew) {
            return <Loading />;
        }

        return (
            <Form method="post" role="form" model="inventoryEquipmentForm">
                <div className="details-field-container">
                    <Select
                        className="form-select required"
                        label={this.toLocaleLanguage('equipment_type_upper')}
                        options={inventoryEquipment.inventoryEquipmentDropdownList.EquipmentTypes}
                        value={inventoryEquipmentForm.equipmentTypeId}
                        placeholder={PLACEHOLDER.SELECT}
                        isError={this.state.isError}
                        fieldProp=".equipmentTypeId"
                    />

                    <InputField
                        className={`form-control required ${this.state.isError ? "border-red" : ""}`}
                        type="text"
                        label={this.toLocaleLanguage('model_upper')}
                        fieldProp=".model"
                        value={inventoryEquipmentForm.model}
                        placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                        maxLength={MAX_LENGTH.limit_100}
                    />

                    <InputField
                        className="form-control"
                        label={this.toLocaleLanguage('product_name_upper')}
                        type="text"
                        fieldProp=".productName"
                        value={inventoryEquipmentForm.productName}
                        placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                        maxLength={MAX_LENGTH.limit_100}
                    />

                    <Select
                        className="form-select required"
                        label={this.toLocaleLanguage('status_capital')}
                        options={inventoryEquipment.inventoryEquipmentDropdownList.EquipmentStatuses}
                        value={inventoryEquipmentForm.equipmentStatusId}
                        placeholder={PLACEHOLDER.SELECT}
                        fieldProp=".equipmentStatusId"
                    />

                    <CustomSearchableDropdownWrapper
                        label={this.toLocaleLanguage('vendor_upper')}
                        options={inventoryEquipment.inventoryAllVendors}
                        selected={inventoryEquipmentForm.vendorId}
                        placeholder={this.toLocaleLanguage('select_placeholder')}
                        requiredField
                        fieldProp="inventoryEquipmentForm.vendorId"
                        tagName="vendorId"
                        optionLabelKey={{ Key: 'Key', Value: 'Value' }}
                        maxLength={MAX_LENGTH.limit_100}
                        onChange={this.handleVendorChange}  
                        onSearchChange={this.handleVendorSearch}
                        onLoadMore={this.loadMoreVendor}
                        isLoading={isVendorLoading}
                        hasMore={hasMoreVendor}
                    />

                    <InputField
                        className="form-control"
                        label={this.toLocaleLanguage('currency_upper')}
                        value={inventoryEquipmentForm.currency}
                        type="text"
                        fieldProp=".currency"
                        disabled={true}
                    />

                    <CustomSearchableDropdownWrapper
                        label={this.toLocaleLanguage('circuit_type_upper')}
                        options={inventoryEquipment.inventoryAllCircuitTypes}
                        selected={inventoryEquipmentForm.circuitTypeId}
                        placeholder={this.toLocaleLanguage('select_placeholder')}
                        requiredField
                        fieldProp="inventoryEquipmentForm.circuitTypeId"
                        tagName="circuitTypeId"
                        optionLabelKey={{ Key: 'Key', Value: 'Value' }}
                        maxLength={MAX_LENGTH.limit_100}
                        onSearchChange={this.handleCircuitTypeSearch}
                        onLoadMore={this.loadMoreCircuitType}
                        isLoading={isCircuitTypeLoading}
                        hasMore={hasMoreCircuitType}
                    />

                    <CustomSearchableDropdownWrapper
                        label={this.toLocaleLanguage('contract_id_upper')}
                        options={inventoryEquipment.inventoryAllContracts}
                        selected={inventoryEquipmentForm.contractId}  
                        placeholder={this.toLocaleLanguage('select_placeholder')}
                        fieldProp="inventoryEquipmentForm.contractId"
                        tagName="contractId"
                        optionLabelKey={{ Key: 'Key', Value: 'Value' }}
                        maxLength={MAX_LENGTH.limit_100}
                        onSearchChange={this.handleContractSearch}
                        onLoadMore={this.loadMoreContract}
                        isLoading={isContractLoading}
                        hasMore={hasMoreContract}
                    />

                    <InputField
                        className="form-control required"
                        label={this.toLocaleLanguage('order_cost_upper')}
                        type="text"
                        fieldProp="inventoryEquipmentForm.orderCost"
                        value={this.convertToDecimal(inventoryEquipmentForm.orderCost)}
                        placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                        inputType={DATA_TYPE.decimal}
                    />

                    <InputField
                        className="form-control"
                        label={this.toLocaleLanguage('discounted_order_cost_upper')}
                        type="text"
                        fieldProp="inventoryEquipmentForm.discountedOrderCost"
                        value={this.convertToDecimal(inventoryEquipmentForm.discountedOrderCost)}
                        placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                        inputType={DATA_TYPE.decimal}
                    />

                    <InputField
                        className="form-control"
                        label={this.toLocaleLanguage('mrc')}
                        type="text"
                        fieldProp="inventoryEquipmentForm.mrc"
                        value={this.convertToDecimal(inventoryEquipmentForm.mrc)}
                        placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                        inputType={DATA_TYPE.decimal}
                    />

                    <InputField
                        className="form-control"
                        label={this.toLocaleLanguage('nrc')}
                        type="text"
                        fieldProp="inventoryEquipmentForm.nrc"
                        value={this.convertToDecimal(inventoryEquipmentForm.nrc)}
                        placeholder={PLACEHOLDER.ENTER_TEXT_HERE}
                        inputType={DATA_TYPE.decimal}                     
                    />

                    <CustomSearchableDropdownWrapper
                        label={this.toLocaleLanguage('gl_code_upper')}
                        options={inventoryEquipment.inventoryAllGlCodes}
                        selected={inventoryEquipmentForm.glCodeId}
                        placeholder={this.toLocaleLanguage('select_placeholder')}
                        fieldProp="inventoryEquipmentForm.glCodeId"
                        tagName="glCodeId"
                        optionLabelKey={{ Key: 'Key', Value: 'Value' }}
                        maxLength={MAX_LENGTH.limit_100}
                        onSearchChange={this.handleGlCodeSearch}
                        onLoadMore={this.loadMoreGlCode}
                        isLoading={isGlCodeLoading}
                        hasMore={hasMoreGlCode}
                    />

                    <CustomSearchableDropdownWrapper
                        label={this.toLocaleLanguage('capital_cost_center')}
                        options={inventoryEquipment.inventoryAllCostCenters}
                        selected={inventoryEquipmentForm.costCodeId}
                        placeholder={this.toLocaleLanguage('select_placeholder')}
                        fieldProp="inventoryEquipmentForm.costCodeId"
                        tagName="costCodeId"
                        optionLabelKey={{ Key: 'Key', Value: 'Value' }}
                        maxLength={MAX_LENGTH.limit_100}
                        onChange={this.handleCostCenterChange}
                        onSearchChange={this.handleCostCenterSearch}
                        onLoadMore={(query) => this.loadMoreCostCenter(query)}
                        isLoading={isCostCenterLoading}
                        hasMore={hasMoreCostCenter}
                        isNullable={true}
                        hasTilde={true}
                    />

                    <CustomSearchableDropdownWrapper
                        label={this.toLocaleLanguage('company_code_upper')}
                        options={inventoryEquipment.inventoryAllCompanyCodes}
                        selected={inventoryEquipmentForm.companyCodeId}
                        placeholder={this.toLocaleLanguage('select_placeholder')}
                        fieldProp="inventoryEquipmentForm.companyCodeId"
                        tagName="companyCodeId"
                        optionLabelKey={{ Key: 'Key', Value: 'Value' }}
                        maxLength={MAX_LENGTH.limit_100}
                        onSearchChange={this.handleCompanyCodeSearch}
                        onLoadMore={this.loadMoreCompanyCode}
                        isLoading={isCompanyCodeLoading}
                        hasMore={hasMoreCompanyCode}
                    />

                    <Select
                        className="form-select no-select__option"
                        label="VIP"
                        options={inventoryEquipment.inventoryEquipmentDropdownList.IsVIPOption}
                        value={inventoryEquipmentForm.vipId}
                        placeholder={PLACEHOLDER.SELECT}
                        fieldProp=".vipId"
                    />
                </div>

                <div className="save-btn-container">
                    <ConfirmationNotificationModal
                        disabled={this.state.acceptConf}
                        show={this.state.showModal}
                        title={this.state.notifTitle}
                        customClass="comment-notification-modal modal-text-bold"
                        handleModal={this.handleConfirmationModal}
                        message={this.state.modalMessage}
                    />

                    <NotificationModal
                        show={this.state.showValidationModal}
                        title={this.state.notifTitle}
                        customClass="comment-notification-modal notification-footer modal-text-bold"
                        handleModal={this.handleValidateModal}
                        message={this.state.modalMessage}
                    />

                    {isReadAndWrite && (
                        <Button
                            className="save-details-btn btn btn-primary"
                            onClick={this.onClick}
                            disabled={this.handleDisableSaveButton() || this.state.isSaving}
                            type="submit"
                        >
                            Save Changes
                        </Button>
                    )}
                </div>
            </Form>
        );
    }
}
export default withRouter(
    connect(
        state => {
            const { inventoryEquipmentDetails, translation, inventoryEquipment } = state;
            const { inventoryEquipmentForm } = state.form;
            return {
                inventoryEquipmentForm
                , inventoryEquipmentDetails
                , inventoryEquipment
                , ...translation
            };
        },
        dispatch => bindActionCreators(
            Object.assign({}
                , inventoryEquipmentActions),
            dispatch
        )
    )(FormView)
);